import { ReactElement, useEffect, useEffectEvent } from "react";
import { useLocation } from "react-router";
import { SpinnerLegacy } from "../../../components";
import { useSellarUser } from "../../../hooks";
import { useApiRequestLegacy } from "../../../hooks/api/v2/useApiRequestLegacy";
import { useFirebaseUser } from "../../../hooks/useFirebaseUser.shared";
import { generateImgixUrl, imageUrls, H1 } from "@sellar-io/components";
import { SignInForm } from "./SignInForm";
import { getOAuthParameter } from "./getOAuthParameter";

export function OAuth2SignIn(): ReactElement {
  const { user } = useFirebaseUser();
  const { loading } = useSellarUser();
  const location = useLocation();

  const authLegacyRequest = useApiRequestLegacy<object, { url: string }>({
    method: "post",
    path: "auth/auth",
  });

  const authenticate = useEffectEvent(() => {
    authLegacyRequest.mutate(
      {
        redirect_uri: getOAuthParameter(location.search, "redirect_uri"),
        state: getOAuthParameter(location.search, "state"),
      },
      {
        onSuccess: (data) => {
          console.log(data);
          window.location.replace(data.url);
        },
      },
    );
  });

  useEffect(() => {
    if (user) authenticate();
  }, [user]);

  if (loading || authLegacyRequest.isPending) return <SpinnerLegacy />;

  if (user) return <SpinnerLegacy />;

  return (
    <div className="pad container mx-auto max-w-[600px]">
      <img
        alt={"Sellar Logo"}
        src={generateImgixUrl(imageUrls.sellarLogo.purple.full, {
          width: 150,
          compress: true,
        })}
        className={"w-[150px]"}
      />
      <H1 className={"my-6"}>Log in to Sellar</H1>
      <SignInForm showForgottenPassword={false} />
    </div>
  );
}
